

const ResponsibleGambling = () => {
  return (
    <div className="rg">
      <div className="rg__container">
        <h1 className="rg__title">Responsible Gambling</h1>

        <section className="rg__section">
          <h2>1. Commitment to Responsible Gambling</h2>
          <p>
            At Ozjackpotclaim, we are committed to promoting responsible gambling. We believe that
            gambling should be a form of entertainment and that it is essential for our players to
            gamble responsibly. We aim to provide a safe and enjoyable environment for all users.
          </p>
        </section>

        <section className="rg__section">
          <h2>2. Understanding the Risks</h2>
          <p>
            Gambling can be an enjoyable pastime; however, it can also lead to problems for some
            individuals. It is essential to be aware of the risks associated with gambling, including:
          </p>
          <ul>
            <li>Financial losses</li>
            <li>Emotional distress</li>
            <li>Impact on personal relationships</li>
          </ul>
          <p>If you or someone you know is experiencing difficulties related to gambling, we encourage you to seek help.</p>
        </section>

        <section className="rg__section">
          <h2>3. Tips for Responsible Gambling</h2>
          <ul>
            <li><strong>Set a Budget:</strong> Establish a spending limit and stick to it.</li>
            <li><strong>Time Management:</strong> Limit your gambling time and take regular breaks.</li>
            <li><strong>Play for Fun:</strong> Treat gambling as entertainment, not income.</li>
            <li><strong>Stay Informed:</strong> Learn the odds and game rules before playing.</li>
          </ul>
        </section>

        <section className="rg__section">
          <h2>4. Self-Exclusion Options</h2>
          <p>
            If you feel that your gambling habits are becoming problematic, we offer self-exclusion
            options. You can choose to exclude yourself from our services for a specified period. For
            more information, please contact our customer support team.
          </p>
        </section>

        <section className="rg__section">
          <h2>5. Support Resources</h2>
          <ul>
            <li><strong>Gambling Help:</strong> Call 1800 858 858 for support and advice.</li>
            <li><strong>GambleAware:</strong> Visit <a href="https://responsiblegambling.vic.gov.au" target="_blank" rel="noopener noreferrer">responsiblegambling.vic.gov.au</a></li>
            <li><strong>BetStop:</strong> Learn more at <a href="https://betstop.gov.au" target="_blank" rel="noopener noreferrer">betstop.gov.au</a></li>
          </ul>
        </section>

        <section className="rg__section">
          <h2>6. Our Responsibility</h2>
          <p>
            We have a responsibility to ensure that our games and services are fair and transparent.
            We regularly review our practices and policies to promote responsible gambling and protect
            our players.
          </p>
        </section>

        <section className="rg__section">
          <h2>7. Underage Gambling</h2>
          <p>
            Gambling is strictly prohibited for individuals under the age of 18. We take this matter
            seriously and employ various measures to prevent underage gambling. If we become aware of
            any underage gambling activities, we will take appropriate action.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ResponsibleGambling;
